import React from 'react';
import { makeStyles } from '@material-ui/core';
import {
    COLOR_WHITE,
    COLOR_PRIMARY_RED,
    COLOR_TREND_UP_GREEN,
    COLOR_GIGGITY,
} from '../../colors';
import { formatTrendPercentage } from '../../../utils';
import { useFormatMessage } from 'react-intl-hooks';

const TREND_ARROWS = {
    trendUp: './images/trending-up.svg',
    trendDown: './images/trending-down.svg',
    trendFlat: './images/trending-flat.svg',
}

const useStyles = makeStyles((theme)=> ({
    trendContainer: {
        display: (props)=> props.display || 'inline-block',
        fontWeight: 500,
        margin: (props)=> props.margin || '0 0 0 12px',
        padding: '4px 6px',
        backgroundColor: COLOR_WHITE,
        borderRadius: '4px',
    },
    trendValueContainer: {
        display: 'flex',
        gap: '4px',
    },
    trendUp: {
        color: COLOR_TREND_UP_GREEN,
    },
    trendDown: {
        color: COLOR_PRIMARY_RED,
    },
    trendFlat: {
        color: COLOR_GIGGITY,
    },
    smallTrendArrow: {
        width: '18px',
    },
    largeTrendArrow: {
        width: '22.5px',
    },
    smallTrendValue: {
        fontSize: '18px',
        lineHeight: '26px',
        fontWeight: 900,
        letterSpacing: '0.15px',
    },
    largeTrendValue: {
        fontSize: '26px',
        lineHeight: '26px',
        fontWeight: 900,
        letterSpacing: '0.15px',
    },
    smallTrendRange: {
        fontSize: '14px',
        lineHeight: '16px',
        fontWeight: 500,
    },
    largeTrendRange: {
        fontSize: '16px',
        lineHeight: '22px',
        fontWeight: 500,
    }
}));

export function HistoricalTrend(props) {
    const {
        value,
        fromMonth,
        toMonth,
        size = 'small',
    } = props;
    const classes = useStyles(props);
    const t = useFormatMessage();
    const formattedTrendPercentage = formatTrendPercentage(value);
    const trendClass = (/^-/).test(formattedTrendPercentage)
        ? 'trendDown'
        : (formattedTrendPercentage === '0%')
            ? 'trendFlat'
            : 'trendUp';
    if(!formattedTrendPercentage) return null;
    return (
        <div className={`${classes.trendContainer} ${classes[trendClass]}`}>
            <div className={classes.trendValueContainer}>
                <img className={classes[`${size}TrendArrow`]} src={TREND_ARROWS[trendClass]} alt="Trend Arrow" />
                <div className={classes[`${size}TrendValue`]}>{formatTrendPercentage(value)}</div>
            </div>
            <div className={classes[`${size}TrendRange`]}>{t({id: fromMonth}).substring(0,3)} - {t({id: toMonth}).substring(0,3)}</div>
        </div>
    );
}
